import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { Subject, takeUntil } from 'rxjs';
import { DatePipe } from '@angular/common';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { GlobalService } from 'src/app/services/global.service';
import { fadeInOutWithBlur, opacity } from 'src/app/core/global-app-animations';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    providers: [DatePipe],
    animations: [
        fadeInOutWithBlur,
        //sidebar animation
        //fake sidebar animation for smooth animation 
        trigger('expandCollapseSidebarFake', [
            state('false', style({ 'margin-left': '300px' })),
            state('true', style({ 'margin-left': '80px' })),
            transition('false => true', animate('300ms cubic-bezier(.51,.38,.57,.85)')),
            transition('true => false', animate('300ms cubic-bezier(.51,.38,.57,.85)')),
            transition(':enter', []),
        ]),
        //content width
        trigger('expandCollapse', [
            state('false', style({ 'width': 'calc(100dvw - 300px)' })),
            state('true', style({ 'width': "calc(100dvw - 80px)" })),
            transition('false => true', animate('300ms cubic-bezier(.51,.38,.57,.85)')),
            transition('true => false', animate('300ms cubic-bezier(.51,.38,.57,.85)')),
            transition(':enter', []),
        ]),
        /*     trigger('opacity', [
              transition(':enter', [
                style({ overflow: 'hidden', opacity: 0, filter: 'blur(40px)', }),
                animate('400ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 1, filter: 'blur(0px)', })),
              ]),
              transition(':leave', [
                style({ overflow: 'hidden', opacity: 1, filter: 'blur(0px)', }),
                animate('400ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 0, filter: 'blur(40px)',})),
              ]),
            ]), */
        opacity
    ],
    standalone: false
})

export class HomeComponent implements OnInit, AfterViewInit {
  isMobile: boolean = false;
  disableWorkingArea: boolean = false;
  getScreenWidth: number = 0;
  getScreenHeight: number = 0;

  sidebarOpen: boolean = false;
  initialLoad: boolean = true;

  @ViewChild('contentView') home: HTMLElement | undefined;

  theEnd$ = new Subject<void>();

  constructor(
    private router: Router,
    private globalService: GlobalService
  ) {

    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  ngOnInit(): void {

    this.isMobile = this.globalService.isMobile()

    if(this.isMobile == true){
      this.sidebarOpen = true;
    }else{
      this.sidebarOpen = false;
    }

    this.globalService.closeSidebar.pipe(takeUntil(this.theEnd$)).subscribe({
      next:()=>{
        this.sidebarOpen = !this.sidebarOpen;
        if(this.isMobile){
          this.globalService.blockScroll.next(this.sidebarOpen);
        }
      }
    })
  }

  closeSidebar(){
    this.globalService.closeSidebar.next();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    if (this.getScreenHeight > this.getScreenWidth) {
      this.isMobile = true;
      this.globalService.blockScroll.next(this.sidebarOpen);
    
    } else {
      this.isMobile = false;
      this.globalService.blockScroll.next(true);
    }
  }

  ngAfterViewInit(): void {

    Promise.resolve().then(() => setTimeout(() => {
      this.initialLoad = false
    }, 500));
    
  }

  

}
